<template>
    <div class="fhv-centent">
        <h4 class="title-topic">Setting - Restore Defaulf Setting</h4>
        <h4 class="des">Restore Broadband Router Settings to the factory defaults. </h4>
        <el-form size="small"  label-position="left" class="fhv-form"
        :disabled="$G_DEVICE_CFG.isReadOnly">
            <el-form-item>
                <el-button type="primary" @click="reset">Restore Defaults Settings</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Reboot from '@/components/reboot.js'
export default {
    methods:{
        reset(){
            this.$confirm('Are you sure you want to restore defaults settings?The device will reboot.','Confirm',{
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {
                let loadingInstance = this.$loading({lock: true})
                axios
                .post("/boafrm/factory",{switchs:"1"})
                .then((response)=>{
                    loadingInstance.close()
                    Reboot.updata(this,"restore defaults settings successfully! The device is restarting please wait...")
                })
            })
            
        },
    }
}
</script>
<style lang='scss' scoped>
.fhv-centent{
    .des{
        font-size: 14px;
        line-height: 1.42857143;
        color: #333; 
        border-top: 1px solid #ddd;   
        border-bottom: 1px solid #ddd;  
        padding: 8px 0; 
        margin-top: 25px;
    }
}
</style>



